import { Box, styled } from '@mui/system';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import noDataIcon from '../../../assets/no-data-icon.svg';

export const StyledDataGrid = styled(DataGrid)<DataGridProps>({
  border: 'none',
  margin: 0,
  '--unstable_DataGrid-overlayBackground': 'transparent',
  '& .MuiDataGrid-columnHeaders': {
    '--unstable_DataGrid-headWeight': 400,
    backgroundColor: '#F3F5F7',
    borderRadius: 0,
    color: '#000000',
    fontWeight: 400,
    fontSize: 14,
    padding: '2px 0px',
    lineHeight: '36px',
    cursor: 'default'
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'inherit'
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none'
  },
  '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
    outline: 'none !important'
  },
  '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
    outline: 'none !important'
  },
  '& .MuiDataGrid-row': {
    borderTop: 'none !important',
    boxSizing: 'border-box',
    '&:first-of-type': {
      border: 'none !important'
    },
    '& .MuiDataGrid-cell': {
      padding: '14px 0px',
      fontWeight: 400,
      fontSize: 14,
      borderBottom: 'none',
      '&:first-child': {
        paddingLeft: 13
      },
      '&:last-child': {
        paddingRight: 13
      }
    },
    '&:last-child .MuiDataGrid-cell': {
      borderBottom: 'none'
    }
  }
});

export const NoDataContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
});

export const NoDataImage = styled(() => <img src={noDataIcon} alt="No Data" />)(() => ({
  display: 'flex',
  width: 80,
  height: 80
}));

export const NoDataTitle = styled(Box)(() => ({
  fontSize: '20px',
  fontWeight: '500',
  color: '#1C3D64',
  marginTop: 10
}));

export const NoDataHint = styled(Box)(() => ({
  fontSize: '14px',
  fontWeight: '400',
  marginTop: 5
}));
